import { render } from "./ActivosPorContrato.vue?vue&type=template&id=524c15a1&scoped=true"
import script from "./ActivosPorContrato.vue?vue&type=script&lang=js"
export * from "./ActivosPorContrato.vue?vue&type=script&lang=js"

import "./ActivosPorContrato.vue?vue&type=style&index=0&id=524c15a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524c15a1"]])

export default __exports__